import {ReactComponent as FACEBOOK} from './svgs/facebook.svg';
import {ReactComponent as TWITTER} from './svgs/twitter.svg';
import {ReactComponent as LINKEDIN} from './svgs/linkedin.svg';
import {ReactComponent as INSTAGRAM} from './svgs/instagram.svg';
import {ReactComponent as GITHUB} from './svgs/github.svg';
import {ReactComponent as DEVELOPER} from './svgs/developer_activity.svg';
import {ReactComponent as PROUD_DEVELOPER} from './svgs/feeling_proud.svg';
import {ReactComponent as SEND} from './svgs/sent-mail.svg';
import {ReactComponent as CLOUD_DOWNLOAD} from './svgs/storage-download.svg';
import {ReactComponent as USER} from './svgs/user.svg';

export const Svgs = {
  FACEBOOK,
  TWITTER,
  LINKEDIN,
  INSTAGRAM,
  GITHUB,
  DEVELOPER,
  PROUD_DEVELOPER,
  SEND,
  CLOUD_DOWNLOAD,
  USER
}